import {
  GAME_ID,
  INIT_DROP_ZONE_LAYOUT,
  TURN_ANIMATED_KNIFE_ON,
  TURN_ANIMATED_KNIFE_OFF,
  TURN_TILE_ANIMATION_ON,
  TURN_TILE_ANIMATION_OFF,
  TURN_DROP_ZONE_ON,
  TURN_DROP_ZONE_OFF,
  SWITCH_ONBOARDING_TILE_ANIMATION,
} from '../data/goblinGourmetConstants';

const initialState = {
  dropZoneLayouts: {},
  animatedKnifeOn: false,
  tileAnimationActive: false,
  activeTileText: null,
  dropZoneActive: false,
  onboardingTileAnimationOn: false,
};

// reducer with different events related to animation
const goblinGourmetAnimationReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case INIT_DROP_ZONE_LAYOUT: {
      const { dropZoneLayout, dropZoneKey } = action.payload;

      return {
        ...state,
        dropZoneLayouts: {
          ...state.dropZoneLayouts,
          [dropZoneKey]: dropZoneLayout,
        },
      };
    }
    case TURN_ANIMATED_KNIFE_ON: {
      return {
        ...state,
        animatedKnifeOn: true,
      };
    }
    case TURN_ANIMATED_KNIFE_OFF: {
      return {
        ...state,
        animatedKnifeOn: false,
      };
    }
    case TURN_TILE_ANIMATION_ON: {
      const { activeTileText } = action.payload;

      return {
        ...state,
        tileAnimationActive: true,
        activeTileText,
      };
    }
    case TURN_TILE_ANIMATION_OFF: {
      return {
        ...state,
        tileAnimationActive: false,
        activeTileText: null,
      };
    }
    case TURN_DROP_ZONE_ON: {
      return {
        ...state,
        dropZoneActive: true,
      };
    }
    case TURN_DROP_ZONE_OFF: {
      return {
        ...state,
        dropZoneActive: false,
      };
    }
    case SWITCH_ONBOARDING_TILE_ANIMATION: {
      const { onboardingTileAnimationOn } = action.payload;

      return {
        ...state,
        onboardingTileAnimationOn,
      };
    }
    default:
      return state;
  }
};

export default goblinGourmetAnimationReducer;
